import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPrinter2"><Path d="M17.5 11.5H21.5V3.5H2.5V11.5H6.5" stroke="currentColor"/><Path d="M6.5 7.5H17.5V20.5H6.5V7.5Z" stroke="currentColor"/><Path d="M10 11.5H14" stroke="currentColor"/><Path d="M10 15.5H12.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPrinter2;
